import React, { Component } from 'react';


import Button from 'material-ui/Button';
import "./flat-ui-button.css";

class FlatUIButton extends Component {
  render() {
    let extraClasses = ''
    if (this.props.white) {
      extraClasses += ' white'
    }
    if (this.props.outline) {
      extraClasses += ' outline'
    }
    if (this.props.longAnswer) {
      extraClasses += ' long-answer'
    }
    if (this.props.centeredAnswer) {
      extraClasses += ' centered-answer'
    }
    if (this.props.size === 'small') {
      extraClasses += ' small'
    }
    if (this.props.variant) {
      extraClasses += ' ' + this.props.variant
    }
    let allowedProps = Object.assign({}, this.props)
    delete allowedProps["white"]
    delete allowedProps["outline"]
    delete allowedProps["onClick"]
    delete allowedProps["longAnswer"]
    delete allowedProps["centeredAnswer"]
    return (
      <Button {...allowedProps} onClick={e => { e.stopPropagation(); this.props.onClick(e) }}
          classes={{ root: 'flat-ui-button root' + extraClasses, label: 'flat-ui-button-label' }}>
        {this.props.children}
      </Button>
    )
  }
}

export default FlatUIButton;


// WEBPACK FOOTER //
// ./src/components/input/flat-ui-button.js